import ClearIcon from "@mui/icons-material/Clear";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import b64toBlob from "b64-to-blob";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SignatureCanvas from "react-signature-canvas";
import mysmartguardplus from "../../../src/assets/USA_Images/applicationLogo.svg";
import { REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION } from "../../actions/EndPoints";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import HeaderToolbar from "../../components/HeaderToolbar";
import ProfileContext from "../../components/ProfileContext";
import Toast from "../../components/ToastContainer/CustomToast";
import CommonUtil from "../../components/Util/CommonUtils";
import httpCommon from "../../config/http-common";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function SelfRegistrationNDADocumentData(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const sigCanvasRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [numPages, setNumPages] = useState(null);

  const [documentIds, setDocumentsIds] = useState([]);
  const [ndaDocuments, setNdaDocument] = useState(
    JSON.parse(localStorage.getItem("ndaDocuments")),
  );
  const [ndaDocumentURL, setNdaDocumentURL] = useState(
    JSON.parse(localStorage.getItem("ndaDocumentURL")),
  );
  const [ndaSignature, setNdaSignature] = useState(
    JSON.parse(localStorage.getItem("ndaSignatures")),
  );
  const [state, setState] = useState(
    JSON.parse(localStorage.getItem("payload")),
  );
  const { setCurrentTotalVisitCount } = useContext(ProfileContext);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [numPages1, setNumPages1] = useState(null);
  const [numPages2, setNumPages2] = useState(null);
  const videoAcknowledgement = props?.location?.state?.videoAcknowledgement;

  const onDocumentLoadSuccess1 = ({ numPages }) => {
    setNumPages1(numPages);
  };

  const convertBase64toBlob = () => {
    var base64Data = localStorage.getItem("profileImage");
    if (base64Data) {
      var contentType = "image/jpeg";
      var blob = b64toBlob(base64Data, contentType);
      return blob;
    }
    return null;
  };
  const [profileImage, setProfileImage] = React.useState(() =>
    convertBase64toBlob(),
  );

  const onDocumentLoadSuccess2 = ({ numPages }) => {
    setNumPages2(numPages);
  };
  const handleClear = () => {
    sigCanvasRef.current.clear();
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [scale, setScale] = useState(1.5);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setWindowWidth(width);
      if (width < 600) {
        setScale(0.6); // Smaller scale for mobile
      } else if (width < 960) {
        setScale(1); // Tablet
      } else {
        setScale(1.5); // Desktop
      }
    };

    handleResize(); // initial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const unblock = history.block((location, action) => {
      if (action === "POP") {
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, []);

  const uploadProfilePhoto = (data) => {
    var bodyFormData = new FormData();
    bodyFormData.append("url", data.profilePhotoURL);
    bodyFormData.append("file", profileImage);
    httpCommon
      .unsecuredMultipartAxios()
      .post("/web/employee/profile", bodyFormData)
      .then(function(response) {
        // Toast("Profile Photo Saved", "success");
      })
      .catch(function(response) {});
  };

  const handleCancel = () => {
    history.push({
      pathname: "/vis/cancel/Visit",
    });
  };

  const config = {
    headers: { companyId: localStorage.getItem("companyId") },
  };

  const handleSubmit = () => {
    if (!agree) {
      Toast("Please agree to NDA Document", "error");
      return;
    }
    if (!sigCanvasRef.current || sigCanvasRef.current.isEmpty()) {
      Toast("Please enter the signature", "error");
      return;
    }
    const updatedSignatures = [
      ...ndaSignature,
      sigCanvasRef.current.getTrimmedCanvas().toDataURL(),
    ];
    const dto = {
      ...state,
      ndaSignatures: updatedSignatures,
      ndaDocuments: ndaDocumentURL,
    };
    if (videoAcknowledgement) {
      history.push({
        pathname: REACT_SAFETY_VIDEO_ACKNOWLEDGEMENT_SELF_REGISTRATION,
        dto: dto,
      });
    } else {
      httpCommon
        .unsecuredAxios()
        .post("/web/visit/create_detail/selfRegistartion", dto, config)
        .then((data) => {
          if (data.data.code === "CVAI0067") {
            setCurrentTotalVisitCount(data.data.data.currentVisitCount);
            if (!CommonUtil.isEmptyString(data.data.data.profilePhotoURL)) {
              // uploadProfilePhoto(data.data.data);
              localStorage.clear();
            }
            history.push({
              pathname: "/vis/visit-success",
              state: { message: data.data.message, success: true },
            });
          } else {
            Toast(data.data.message, "error");
          }
        });
    }
  };
  const [agree, setAgree] = useState(false);
  const handleCheckBox = (event) => {
    setAgree(event.target.checked);
  };

  return (
    <>
      <Box
        style={{
          backgroundColor: "#F4F6F8",
          height: "100vh",
        }}
      >
        <Grid
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Grid container alignItems="center">
            <Grid item className="logo-center">
              <img
                src={mysmartguardplus}
                alt="logo"
                style={{ width: "300px" }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Box
          sx={{
            backgroundColor: "white",
            height: "calc(100vh - 110px)",
            display: "flex",
            flexDirection: "column",
            marginRight: isSmallScreen ? "0px" : "70px",
            marginLeft: isSmallScreen ? "0px" : "70px",
            borderRadius: "10px",
            // gap: "8px",
          }}
        >
          <Grid
            style={{
              paddingLeft: "16px",
              paddingTop: "16px",
            }}
          >
            <HeaderToolbar title={t("NDA_DOCUMENT_SIGNATURE_HEADER")} />
          </Grid>
          <Box
            sx={{
              flex: 1,
              height: "100%",
              overflowY: "auto",
              marginTop: "10px",
            }}
          >
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#FBFBFB",
                  padding: isSmallScreen ? "0px" : "20px",
                  paddingBottom: "0px",
                }}
              >
                <Box
                  sx={{
                    height: "100%",
                    overflowY: "auto",
                  }}
                >
                  <Document
                    file={ndaDocuments[1]?.documentURL}
                    onLoadSuccess={onDocumentLoadSuccess1}
                  >
                    {[...Array(numPages1)].map((_, index) => (
                      <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        renderAnnotationLayer={false}
                        renderTextLayer={false}
                        scale={scale}
                        className="pdf-page"
                      />
                    ))}
                  </Document>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              padding: "20px",
              paddingTop: "4px",
            }}
          >
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                style={{
                  paddingBottom: "0px",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleCheckBox}
                        sx={{
                          "&.Mui-checked": {
                            color: "rgb(242, 130, 76)",
                          },
                          color: "#949596",
                          "&.Mui-disabled": {
                            color: "#949596",
                          },
                        }}
                      />
                    }
                    label={t("NDA_MANDATORY")}
                    style={{
                      color: "rgba(71, 74, 78, 1)",
                    }}
                  />
                </FormGroup>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                style={{
                  paddingBottom: "0px",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    position: "relative",
                    height: "120px",
                    border: "1px solid rgba(112, 112, 112, 0.5)",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <IconButton
                    onClick={handleClear}
                    size="small"
                    sx={{
                      position: "absolute",
                      top: 4,
                      right: 4,
                      zIndex: 1,
                      backgroundColor: "white",
                      "&:hover": {
                        backgroundColor: "#f0f0f0",
                      },
                    }}
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                  <SignatureCanvas
                    ref={sigCanvasRef}
                    penColor="black"
                    canvasProps={{
                      className: "sigCanvas",
                      width: 600,
                      height: "100%",
                      style: {
                        width: "100%",
                        height: "100%",
                        display: "block",
                      },
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                style={{
                  display: "flex",
                  alignItems: "end",
                  // justifyContent: "center",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Grid item>
                    <CancelButtons
                      color="secondary"
                      onClick={handleCancel}
                      variant="contained"
                    >
                      <Typography>{t("APPROVE003")}</Typography>
                    </CancelButtons>
                  </Grid>
                  <Grid item>
                    <SubmitButtons
                      type="submit"
                      onClick={handleSubmit}
                      variant="contained"
                    >
                      <Typography>{t("COMMON007")}</Typography>
                    </SubmitButtons>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default SelfRegistrationNDADocumentData;
